var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintainPage"},[_c('head-guide'),_vm._v(" "),_c('aside-menu'),_vm._v(" "),_c('div',{staticClass:"commonPage",style:({height:_vm.pageHeight + 'px',width:_vm.pageWidth + 'px'})},[_c('vue-scroll',{staticClass:"content"},[_c('tabs')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-01c77924","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/basics/generalContainer.vue
// module id = null
// module chunks = 